// impostazioni da unire nell'elemento config dei parametri di costruzione dei brackets
// sono le impostazioni condivise in ogni applicazione

import app_data from '../../js/globali/get-app-data';
import {print_icon} from '@massimo-cassandro/m-utilities/boilerplate-twig-src/print-icon';

const config = {
  noshow_icon: print_icon('noshow-line', 'icona icona-noshow', app_data.icons)
};

export default config;
